import React from "react"
import { ChevronLeft } from "react-bootstrap-icons"
import { Navbar, Button } from "react-bootstrap"
import { back_event, localize } from "services/base"

const Navigation = () => {
	const t = (key) => localize(key)

	return (
		<Navbar bg="light" className="navigation ps-3 ps-lg-4 pe-3 pe-lg-4 py-1 justify-content-between">
			<Navbar.Brand>
				<img src={t("img_logo")} width="90" height="25" alt="Garena logo" />
			</Navbar.Brand>
			<Button variant="danger" className="back-to" onClick={() => back_event()}>
				<ChevronLeft /> Back to event
			</Button>
		</Navbar>
	)
}

export default Navigation
